import {NgModule,Component,Input,Output,EventEmitter,ElementRef,ContentChild,ChangeDetectionStrategy} from '@angular/core';
import { BlockableUI } from 'primeng/api/public_api';

@Component({
    selector: 'cria-panel',
    templateUrl:'./painel.component.html',
    styleUrls:['./painel.component.css']
})
export class PainelComponent  {

    constructor(private el: ElementRef) {}

    @Input() header: string;

    @Input() hasFooter: boolean=true;

    @Input() hasBackButton: boolean=false;
    @Input() hasTop: boolean=false;
    

}


@Component({
    selector: 'cria-panel-footer',
    template: '<ng-content></ng-content>'
})
export class PanelFooter {}

@Component({
    selector: 'cria-panel-content',
    template: '<ng-content></ng-content>'
})
export class PanelContent {}

@Component({
    selector: 'cria-panel-header',
    template: '<ng-content></ng-content>'
})
export class PanelHeader {}


